export default class SiteService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(site, options) {
    const response = await fetch(`${this.baseUri}/site`, {
      body: JSON.stringify(site),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/site/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/site/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/site`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async getAllExternal(options) {
    const response = await fetch(`${this.baseUri}/site/external`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async import(sites, deleteMissing, options) {
    const response = await fetch(`${this.baseUri}/site/import?deleteMissing=${deleteMissing}`, {
      body: JSON.stringify(sites),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return response.ok
  }

  async update(id, site, options) {
    const response = await fetch(`${this.baseUri}/site/${id}`, {
      body: JSON.stringify(site),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}